export enum IntegrationEnum {
  SLACK = "Slack",
  GOOGLE_DRIVE = "Google Drive",
  GitHub = "GitHub",
}

export const boardIntegrations = [IntegrationEnum.SLACK];
